import axios from 'axios';
import topAlbumsMock from '../mockData/topAlbums.json';
import newAlbumsMock from '../mockData/newAlbums.json';
import songsMock from '../mockData/songs.json';

export const BACKEND_ENPOINT = "https://qtify-backend-labs.crio.do"

export const fetchTopAlbums = async() => {
    try{
        const res = await axios.get(`${BACKEND_ENPOINT}/albums/top`);
        return res.data
    }catch(error){
        console.error("fetchTopAlbums failed, using mock data", error);
        return topAlbumsMock;
    }
}
export const fetchNewAlbums = async() => {
    try{
        const res = await axios.get(`${BACKEND_ENPOINT}/albums/new`);
        return res.data
    }
    catch(error){
        console.error("fetchNewAlbums failed, using mock data", error);
        return newAlbumsMock;
    }
}

export const fetchSongs = async() => {
    try{
        const res = await axios.get(`${BACKEND_ENPOINT}/songs`);
        return res.data
    }
    catch(error){
        console.error("fetchSongs failed, using mock data", error);
        return songsMock;
    }
}